import { NonConformityStationModel } from '../models/non-conformity-station';

export class NonConformityStationAdapter {
  static fromApi(data: any): NonConformityStationModel {
    return {
      id: data.id,
      identifier: data.identifier,
      description: data.description,
      active: data.active,
    };
  }
}
